// extracted by mini-css-extract-plugin
export default {"container":"itemComp_container__gZ-mo","rightBox":"itemComp_rightBox__V0zVx"};